export default "__VITE_ASSET__D1mvGphm__"